/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

// Summary And Greeting Section

import emoji from "react-easy-emoji";

const illustration = {
  animated: false // set to false to use static SVG
};

const greeting = {
  username: "Valentina Pugliese",
  title: "Welcome to Valentina Pugliese's Site!",
  subTitle: emoji(
    "A passionate and an aspiring young lady 🎤 who wishes to pursue a career in zoology and a hobby in voice acting"
  ),
  resumeLink:
    "https://drive.google.com/file/d/1rQbPx5hk6UXPdD494x2pGWVPwQVKAHYE/view?usp=sharing",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  discord: "https://discordapp.com/users/269682632038678528/",
  gmail: "vpvictorious.mail@gmail.com",
  twitter: "https://twitter.com/LilCrispyVal",
  // Instagram and Twitter are also supported in the links!
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "Researching Widlife & Acting is what I do best and so much more too!",
  skills: [
    emoji(
      "𝘛𝘪𝘳𝘦𝘥 𝘰𝘧 𝘭𝘢𝘻𝘺, 𝘶𝘯𝘳𝘦𝘴𝘱𝘰𝘯𝘴𝘪𝘷𝘦 𝘩𝘪𝘳𝘦𝘴? 𝘎𝘦𝘵 𝘓𝘪𝘭𝘊𝘳𝘪𝘴𝘱𝘺𝘍𝘶𝘺𝘶 𝘰𝘯 𝘺𝘰𝘶𝘳 𝘵𝘦𝘢𝘮, 𝘺𝘰𝘶 𝘸𝘰𝘯'𝘵 𝘳𝘦𝘨𝘳𝘦𝘵 𝘪𝘵. 𝘈𝘴 𝘢 𝘝𝘰𝘪𝘤𝘦 𝘈𝘤𝘵𝘰𝘳 𝘵𝘰 𝘢𝘯 𝘈𝘶𝘥𝘪𝘰 𝘌𝘯𝘨𝘪𝘯𝘦𝘦𝘳, 𝘓𝘪𝘭𝘊𝘳𝘪𝘴𝘱𝘺𝘍𝘶𝘺𝘶 𝘸𝘪𝘭𝘭 𝘢𝘭𝘸𝘢𝘺𝘴 𝘵𝘳𝘺 𝘩𝘦𝘳 𝘣𝘦𝘴𝘵 𝘢𝘯𝘥 𝘵𝘰 𝘮𝘦𝘢𝘴𝘶𝘳𝘦 𝘶𝘱 𝘵𝘰 𝘺𝘰𝘶𝘳 𝘴𝘵𝘢𝘯𝘥𝘢𝘳𝘥𝘴. 𝘐𝘵'𝘴 𝘢 𝘱𝘭𝘦𝘢𝘴𝘶𝘳𝘦 𝘸𝘰𝘳𝘬𝘪𝘯𝘨 𝘸𝘪𝘵𝘩 𝘩𝘦𝘳 𝘢𝘯𝘥 𝘩𝘦𝘳 𝘩𝘢𝘳𝘥 𝘸𝘰𝘳𝘬𝘪𝘯𝘨 𝘯𝘢𝘵𝘶𝘳𝘦 𝘴𝘩𝘪𝘯𝘦𝘴 𝘵𝘩𝘳𝘰𝘶𝘨𝘩 𝘩𝘦𝘳 𝘸𝘪𝘭𝘭𝘪𝘯𝘨𝘯𝘦𝘴𝘴 𝘵𝘰 𝘤𝘰𝘮𝘮𝘶𝘯𝘪𝘤𝘢𝘵𝘦 𝘢𝘯𝘥 𝘱𝘳𝘰𝘣𝘭𝘦𝘮 𝘴𝘰𝘭𝘷𝘦. - 𝘚𝘦𝘪𝘫𝘪𝘉"
    ),
    emoji(""),
    emoji(
      ""
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Voice Acting",
      fontAwesomeClassname: "fas fa-microphone-alt"
    },
    {
      skillName: "Audio Engineer",
      fontAwesomeClassname: "fas fa-play"
    },
    {
      skillName: "Wildlife Expert",
      fontAwesomeClassname: "fas fa-paw"
    },
    {
      skillName: "Intermediate Coder",
      fontAwesomeClassname: "fas fa-code-branch"
    },
    {
      skillName: "Leadership",
      fontAwesomeClassname: "fas fa-tasks"
    },
    {
      skillName: "Communication",
      fontAwesomeClassname: "fas fa-volume-up"
    },
    {
      skillName: "Organizer",
      fontAwesomeClassname: "fas fa-copy"
    },
    {
      skillName: "Mathematics",
      fontAwesomeClassname: "fas fa-square-root-alt"
    },
    {
      skillName: "Zoology",
      fontAwesomeClassname: "fas fa-bone"
    },
    {
      skillName: "Marine Biology",
      fontAwesomeClassname: "fas fa-fish"
    },
    {
      skillName: "Science",
      fontAwesomeClassname: "fas fa-flask"
    },
    {
      skillName: "Music",
      fontAwesomeClassname: "fas fa-music"
    },
    {
      skillName: "Dance",
      fontAwesomeClassname: "fas fa-guitar"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Xceed Prepratory Academy",
      logo: require("./assets/images/xceedlogo.png"),
      subHeader: "",
      duration: "September 2018 - xxPresent",
      desc: "Honors Student",
      descBullets: [
        "Graduating in May 2022",
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Wildlife CareTaker & Expert", //Insert stack or technology you have experience in
      progressPercentage: "100%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Acting",
      progressPercentage: "80%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: true // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Pottur",
      company: "Wynncraft",
      companylogo: require("./assets/images/wynncraft.webp"),
      date: "June 2021 – Present",
      desc: "Pottur is the starting NPC for the quest Studying the Corrupt. He, along with Dumble and Dure, needs your help to break the spell guarding the Lost Sanctuary to get to Garoth.",
      descBullets: [
        "Dumble, Dure, and Pottur are references to Harry Potter and Dumbledore from the Harry Potter series.",
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "false", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Accomplishment(s) I'm proud to display of!",

  achievementsCards: [
    {
      title: "Summer Scholars Program",
      subtitle:
        "Marine Mammal Biology, Evolution, and Conservation",
      image: require("./assets/images/summerscholarprogram.webp"),
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1x6brHLzC3lrRrbf_ewS8Gqls5xPQVzvj/view?usp=sharing"
        },
        {
          name: "Summer Scholar Program Information",
          url: "https://ssp.dcie.miami.edu/program-information/academic-landing/2020-remote/index.html"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Demo Reel 🎙️"),
  subtitle: "Valentina Pugliese's Demo Reel!",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/valentina7167/embed/episodes/Valentina-Pugliese--Demo-Reel-e13m7ni/a-a6188oe"
  ],
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "",
  email_address: "vpvictorious.mail@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
